import { render } from "./testimonial.vue?vue&type=template&id=4148eae8&scoped=true&ts=true"
import script from "./testimonial.vue?vue&type=script&lang=ts"
export * from "./testimonial.vue?vue&type=script&lang=ts"

import "./testimonial.vue?vue&type=style&index=0&id=4148eae8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4148eae8"]])

export default __exports__